import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService, ConfigService } from '@assist/shared/data';
import { ApiService, qrCodeInfo } from '@cue/api';

@Injectable({
  providedIn: 'root',
})
export class QrCodeGuard implements CanActivate {
  public router = inject(Router);
  public apiService = inject(ApiService);
  public authService = inject(AuthService);
  public configService = inject(ConfigService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> | UrlTree | Observable<UrlTree> {
    // Multiview flow
    // proteus http://localhost:4201/dashboard?multiview=f1c44fc7-a94b-4c71-858f-03fb6d79b880
    // Novinka: http://localhost:4201/qr/5dab45e7-b15a-4db0-9d17-bf3192ba801e
    // hefaistos http://localhost:4201/qr/ba3a811a-06c1-4ffa-b199-5aa5df8d579a
    // Microoffice 2 http://localhost:4201/qr/a5eee909-7d0c-4cee-aea6-4e3795be4456
    // MO 2 Sensor  http://localhost:4201/qr/7b256d9d-0968-4b59-9b2f-de5dd4d753b1
    // Infusion therapy http://localhost:4201/qr/fc3466c9-a380-400b-8b00-faa468d6a35e

    // Proteus - device na nem
    // http://localhost:4201/qr/bfa35752-f283-4975-b7a1-d4b16d215121
    // opdovida
    // https://dnavigation.cuesystem.online/?openedQrCodeId=bfa35752-f283-4975-b7a1-d4b16d215121

    // SIgned out:
    // http://localhost:4201/account/login?multiview=7ab4056c-154a-4139-b3e2-60dd7533933d
    const id = route.params['id'];
    if (this.configService.value.forceResourceToNavigation) {
      const navigationUrl = this.configService.value.navigationAppUrl;
      window.location.href = navigationUrl + '?startQrCodeId=' + id + '&scanQr=true';
    } else {
      const tabQueryParam = route.queryParams['tab'];
      const isAssistUser = this.authService.getApiRefreshToken() != null;
      return this.router.createUrlTree(isAssistUser ? ['/dashboard'] : ['/account/login'], {
        queryParams: {
          multiviewQr: id,
          multiviewQrScannedAt: Date.now(),
          ...(tabQueryParam ? { tab: tabQueryParam } : {}),
        },
      });
    }

    const params = route.queryParams;
    const resourceId = params['resourceId'];
    const newsId = params['newsId'];

    if (newsId !== null && newsId !== undefined && newsId !== 'null') {
      return this.router.parseUrl('/news/' + newsId);
    }
    if (
      resourceId !== null &&
      resourceId !== undefined &&
      resourceId !== 'null' &&
      !this.configService.value.forceResourceToNavigation
    ) {
      return this.router.parseUrl('/reservations/reserve/' + resourceId + '?split=');
    }

    return this.apiService
      .call(
        qrCodeInfo(
          id,
          (x) => {
            //TOUCH-2290 QR code not found
            if (x.status === 404) {
              return this.router.parseUrl('/dashboard');
            }
            return null;
          },
          false
        )
      )
      .pipe(
        map((response) => {
          if (response.success) {
            // je asist uzivatel
            const isAssistUser = this.authService.getApiRefreshToken() != null;
            const resourceId = response.data.resourceId;
            const resourceGuid = response.data?.resourceGuid;
            const resourceNotAvailable = response.data?.resourceNotAvailable;
            const newsId = response.data.newsId;
            const hasLocation = response.data?.hasLocation;

            const navigationEnabled = response.data?.navigationEnabled;
            const navigationUrl = response.data?.navigationUrl;
            const qrCodeId = response.data?.qrId;

            const startAreaId = response.data?.startAreaId;

            if (!isAssistUser) {
              if (response.data?.qrCodeInNonNavigableArea) {
                // this.configService.value.forceResourceToNavigation
                if (hasLocation && true) {
                  return this.router.parseUrl(
                    '/navigation?qrCodeInNonNavigableArea=true&scanQr=true&startQrCodeId=' + qrCodeId
                  );
                } else {
                  return this.router.parseUrl('/dashboard');
                }
              }
              // pokud je zapnuta navigace, uvazuje se jeste jine flow
              if (navigationEnabled && navigationUrl) {
                // Pokud ma lokaci, pouzije se jako start
                if (hasLocation) {
                  window.location.href =
                    navigationUrl + '?areaId=' + startAreaId + '&scanQr=true&startQrCodeId=' + qrCodeId;
                }
              }
            }

            if (newsId != null && newsId !== undefined) {
              return this.router.parseUrl('/news/' + newsId);
            }
            if (resourceGuid != null && resourceGuid !== undefined && !resourceNotAvailable) {
              return this.router.createUrlTree(['/dashboard'], {
                queryParams: { multiviewResource: resourceGuid },
              });
            }

            if (hasLocation) {
              if (this.configService.value.forceResourceToNavigation) {
                window.location.href = navigationUrl + '?startQrCodeId=' + qrCodeId + '&scanQr=true';
              } else if (!response.data?.qrCodeInNonNavigableArea) {
                return this.router.parseUrl('/navigation?startQrCodeId=' + qrCodeId + '&scanQr=true');
              }
            }
            return this.router.parseUrl('/dashboard');
          } else {
            return this.router.parseUrl('/dashboard');
          }
        })
      );
  }
}
